var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "breadcrumbs-bullet",
  "use": "breadcrumbs-bullet-usage",
  "viewBox": "0 0 4 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 4\" id=\"breadcrumbs-bullet\"><circle cx=\"106\" cy=\"12\" r=\"2\" fill=\"#707070\" fill-rule=\"evenodd\" transform=\"translate(-104 -10)\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol